import $ from 'jquery';

const SELECTORS = {
    SITE_CONTACT_FORM : '.site-contact-details-form',
    LOADING_DOC_RADIOS: '.onsite-radio',
    UNLOADING_TEXTAREA: '.unloadingRequirement-block'
}


export default class CheckoutInfoView{

    constructor($element) {
        console.log($element, 'checkout info loaded')
            this.$element = $element;
            return this.setupHandlers()
                .createChildren()
                .enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */
     setupHandlers() {
        // this.onPlaceOrderSubmitHandler = this.siteDetailsFormSubmit.bind(this);
        this.loadingDockHandler = this.loadingDockCheck.bind(this);
        return this;
    }

    /**
     * createChildren
     *
     * @method createChildren
     * @public
     * @chainable
     */
     createChildren() {
        this.$siteContactForm = this.$element.find(SELECTORS.SITE_CONTACT_FORM);
        this.$onsiteRadioButtons = this.$element.find(SELECTORS.LOADING_DOC_RADIOS);
        this.$unloadingInput = this.$element.find(SELECTORS.UNLOADING_TEXTAREA);
        return this;
    }
    /**
     * Enable
     *
     * @method enable
     * @public
     * @chainable
     */
     enable() {
        this.$onsiteRadioButtons.on('click',(e) => this.loadingDockHandler(e.target.value));
        this.$onsiteRadioButtons.each((index, radio) => {
            if(radio.checked){
               this.loadingDockCheck(radio.value)
           }
        })
        return this;
    }

    

    loadingDockCheck(dock){
        console.log(dock)
        if(dock && dock === 'false'){
            this.$unloadingInput[0].classList.remove('u-displayNone')
            this.$unloadingInput[0].querySelector('textarea').setAttribute(
                "required" , "true"
            )
        }else if(dock && dock === 'true'){
            this.$unloadingInput[0].querySelector('textarea').removeAttribute("required")
            this.$unloadingInput[0].classList.add('u-displayNone')
            
        }
    }
}